import {useEffect, useState} from "react";
import useService from "./useService";
import {useTranslation} from "react-i18next";

const initialMessage = {
  status: null,
  content: "",
};

export default listId => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState(initialMessage);
  const [sentRequest, setSentRequest] = useState(false);

  const {t} = useTranslation();

  const SUCCESS_MSG = t("newsletter.success");
  const ERROR_MSG = t("newsletter.error");

  const {loading, serviceCall: onSubmit} = useService(async () => {
    try {
      setMessage({
        status: "loading",
        content: "Loading...",
      });

      setSentRequest(true);

      const formData = new URLSearchParams();
      formData.append('g', listId);
      formData.append('email', email);

      // Add custom fields from the options object
      const options = {
        $fields: ["newsletter_signup_page"],
        newsletter_signup_page: document.location
      };

      Object.keys(options).forEach(key => {
        formData.append(key, options[key]);
      });

      const resp = await fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
        method: "POST",
        headers: {
          "Access-Control-Allow-Headers": "*",
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
        },
        body: formData
      }).then(response => response.json());

      if (!resp.success) {
        throw new Error(resp);
      }

      setMessage({
        status: "success",
        content: SUCCESS_MSG,
      });
      return resp;
    } catch (e) {
      setMessage({
        status: "error",
        content: ERROR_MSG,
      });

      throw e;
    }
  });

  useEffect(() => {
    let timeout = null;

    if (message.status) {
      timeout = setTimeout(() => {
        setMessage(initialMessage);
        setEmail("");
        setSentRequest(false);
      }, 3000);
    }

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [message]);

  return {loading, message, onSubmit, email, setEmail, sentRequest};
};
